export var ViewPopupBackdropType;
(function (ViewPopupBackdropType) {
    ViewPopupBackdropType[ViewPopupBackdropType["Shadow"] = 0] = "Shadow";
    ViewPopupBackdropType[ViewPopupBackdropType["Musk"] = 1] = "Musk";
})(ViewPopupBackdropType || (ViewPopupBackdropType = {}));
